<!-- <svelte:options tag="contact-form" /> -->
<script lang="ts">
    // only for building external css file in dist
    import "../index.css"

    import { onMount } from "svelte"
    import { cryptchaSolution, cryptchaSolutionId, initCryptcha, resetCryptcha, cryptchaStep } from "../utils"
    import CryptchaUI from "cryptcha/src/Cryptcha.svelte"

    export let form_id: string
    export let cryptcha_site_id: string

    if (typeof window !== "undefined") console.log("ContactForm initialized")

    const data = {
        salutation: "",
        firstname: "",
        lastname: "",
        street: "",
        city: "",
        phone: "",
        email: "",
        callback: false,
        message: "",
        _s: "",
        _sId: "",
    }

    let placeholder = "Anrede"

    onMount(() => {
        initCryptcha(cryptcha_site_id)
    })

    let loading = false
    let success = false

    async function submit() {
        loading = true

        data._s = $cryptchaSolution
        data._sId = $cryptchaSolutionId

        console.log(data)

        const response = await fetch("https://dock17.wm-api.tibicms.de/api/form-receiver?formId=" + form_id, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })

        if (response.status === 200) {
            success = true
        } else {
            console.log(response)
            alert("Fehler beim Senden der Daten. Bitte versuchen Sie es erneut.")
        }

        loading = false
        resetCryptcha()
    }
</script>

<div class="contactForm">
    {#if success}
        <div class="success">
            <h2>Vielen Dank für Ihre Kontaktaufnahme!</h2>
            <p>Ihre Nachricht wurde weitergeleitet.</p>
        </div>
    {:else}
        <form on:submit|preventDefault="{submit}" class="forms" class:loading="{loading}">
            <div class="heading">
                <h3 class="">Anfrageformular</h3>
            </div>
            <div class="row-fluid form-group">
                <div class="form-group span6">
                    <select id="select-1" class="form-control" name="salutation" bind:value="{data.salutation}">
                        {#if placeholder}
                            <option value="" disabled selected>{placeholder}</option>
                        {/if}
                        <option class="">Herr</option>
                        <option class="">Frau</option>
                    </select>
                </div>
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="Vorname *"
                        name="firstname"
                        required
                        bind:value="{data.firstname}"
                    />
                </div>
            </div>
            <div class="row-fluid form-group">
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="Name *"
                        name="lastname"
                        required
                        bind:value="{data.lastname}"
                    />
                </div>
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="Straße, Nr."
                        name="street"
                        bind:value="{data.street}"
                    />
                </div>
            </div>
            <div class="row-fluid form-group">
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="PLZ, Ort"
                        name="city"
                        bind:value="{data.city}"
                    />
                </div>
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="E-Mail"
                        name="email"
                        bind:value="{data.email}"
                    />
                </div>
            </div>
            <div class="row-fluid form-group">
                <div class="span6">
                    <input
                        type="text"
                        class="input-block-level"
                        placeholder="Telefon *"
                        name="phone"
                        required
                        bind:value="{data.phone}"
                    />
                </div>

                <div class="span6 checkbox">
                    <input type="checkbox" name="callback" bind:checked="{data.callback}" />
                    <span> Ich bitte um einen Rückruf. </span>
                </div>
            </div>
            <div class="row-fluid form-group">
                <div class="span12">
                    <textarea
                        rows="3"
                        class="input-block-level"
                        placeholder="Ihre Mitteilung"
                        name="message"
                        bind:value="{data.message}"></textarea>
                </div>
                <div class="row-fluid form-group">
                    <div class="span12 checkbox  privacy ">
                        <input type="checkbox" name="formdata--9" data-required="privacy" required />
                        <span>
                            Ich habe die <a
                                href="https://www.wgm-muehlhausen.de/datenschutz"
                                target="_blank"
                                rel="noreferrer">Datenschutzerklärung</a
                            >
                            und die
                            <a
                                href="https://www.wgm-muehlhausen.de/documents/1708358/1745085/Formular_Angaben+Mietvertrag_WG+MHL_WGM.pdf/c3cdbec1-ff5c-4f9f-95d1-ced34af665f6"
                                target="_blank"
                                rel="noreferrer">Information bei Datenerhebung</a
                            > zur Kenntnis genommen und akzeptiere die Bedingungen.
                        </span>
                    </div>
                </div>
            </div>
            <div class="cryptcha"><CryptchaUI {...$cryptchaStep} /></div>

            <div>
                <button type="submit" class="btn cta" disabled="{!$cryptchaSolution || loading}"
                    >{#if loading}bitte warten...{:else}absenden{/if}</button
                >
            </div>
        </form>
    {/if}
</div>

<style lang="less">
    div.contactForm button:disabled {
        opacity: 0.3;
    }
</style>
